import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { clsx } from 'clsx';

import renderUnitIcon from '../utils/renderUnitIcon';

import type IUnitLinkPicker from '../interfaces/IUnitLinkPicker';

import styles from '../scss/UnitLinkField.module.scss';

function UnitLinkPicker({
  id,
  isOpen,
  dropdownRef,
  position,
  searchTerm,
  onSearchTermChange,
  options,
  selectedKeys,
  onOptionToggle,
}: IUnitLinkPicker) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      id={id}
      ref={dropdownRef}
      className={styles.picker}
      style={position}
      role="listbox"
      aria-multiselectable="true"
    >
      <div className={styles.pickerSearch}>
        <input
          type="text"
          value={searchTerm}
          onChange={onSearchTermChange}
          placeholder={t('common.searchByName')}
          className={styles.pickerInput}
        />
      </div>
      <div className={styles.pickerOptions}>
        {options.length ? options.map((option) => {
          const isSelected = selectedKeys.has(option.itemKey);
          return (
            <button
              key={option.itemKey}
              type="button"
              className={clsx(styles.pickerOption, {
                [styles.pickerOptionSelected]: isSelected,
              })}
              onClick={() => onOptionToggle(option)}
              role="option"
              aria-selected={isSelected}
            >
              <span className={styles.pickerOptionIcon} aria-hidden="true">
                {renderUnitIcon(option.type)}
              </span>
              <span className={styles.pickerOptionLabel}>{option.name}</span>
              {isSelected ? (
                <span className={styles.pickerOptionCheck} aria-hidden="true">
                  <CheckIcon />
                </span>
              ) : null}
            </button>
          );
        }) : (
          <div className={styles.pickerEmptyState}>
            {t('common.noResultsFound')}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}

export default UnitLinkPicker;
